import { Action } from '@ngrx/store';
import {
    BalanceEntry,
    BalanceFilterInput
} from 'app/api/balance.api.service';
import { KeyStringFilterInput } from 'app/api/common.api.types';

export interface BalanceQuery {
    companyId: string;
    key?: KeyStringFilterInput;
    filter?: BalanceFilterInput;
}

export enum BalanceActionTypes {
    BalanceRequested = '[Balance View] Balance requested',
    BalanceLoaded = '[Balance API] Balance loaded',
    BalanceCancelled = '[Balance API] Balance cancelled',
}

export class BalanceRequested implements Action {
    readonly type = BalanceActionTypes.BalanceRequested;
    constructor(public payload: BalanceQuery) {}
}
export class BalanceLoaded implements Action {
    readonly type = BalanceActionTypes.BalanceLoaded;
    constructor(public payload: { balance: BalanceEntry[] }) {}
}
export class BalanceCancelled implements Action {
    readonly type = BalanceActionTypes.BalanceCancelled;
    constructor(public payload: { errorMessage: string }) {}
}

export type BalanceActions =
  BalanceRequested
    | BalanceLoaded
    | BalanceCancelled;
